import Bridge from '@public/lib/Bridge'

export function setTitle ({isAPP, title}) {
  title = title.replaceAll('&ldquo;', '“').replaceAll('&rdquo;', '”')
  if (isAPP) {
    let myBridge = new Bridge();
    let appEl = document.querySelector('#app');
    myBridge.call('setTitle', {title: title});
    if (appEl) {
      appEl.classList.remove('app-page--has-topbar');
    }
  }
  document.querySelector('title').innerText = title;
  let detailTitleBar = document.querySelector('.topbar-title .d-ibm');
  if (detailTitleBar) {
    detailTitleBar.innerText = title;
  }

  console.log('---设置title---', title);
}

/**
 * 对多字节 emoji 进行转换 HTML 字符实体的处理
 * @param str
 * @returns {string|*}
 */
export function utf16toEntities(str) {
  const patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  str = String(str);
  str = str.replace(patt, function (char) {
    var H, L, code;
    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位
      L = char.charCodeAt(1); // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法
      return '&#' + code + ';';
    } else {
      return char;
    }
  });
  return str;
}
/**
 * 将字符串内部的/n/r换成<br/>
 * @param str
 */
export function changeLineToBr(str) {
  var reg = new RegExp('%0A', 'g');

  str = escape(str).replace(reg, '%3Cbr/%3E');

  return str;
}

// 获取当前运行的平台
export function getPlatform() {
  var ua = navigator.userAgent, // 获取浏览器UA
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isWechat = /(?:MicroMessenger)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isiPhone && !isAndroid && !isSymbian,
    isYixinliApp = /(?:yixinliApp)/.test(ua),
    isCeShiApp = /(?:XinLiCeShiApp)/.test(ua);
  return {
    isWechat: isWechat,
    isTablet: isTablet,
    isiPhone: isiPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isYixinliApp: isYixinliApp,
    isCeShiApp
  };
}



// WEBPACK FOOTER //
// ./src/util/tool.js